// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"167":"aae22195","498":"c07f8b98","645":"05e068a9"}[chunkId] + ".js";
};